import { useQuery } from '@tanstack/react-query';
import { Link, useParams } from 'react-router-dom';

import { companyApi } from '@/api';
import { Icon, PageHeader } from '@/components/ui';
import { ApplicationsReceived } from '@/features/applications/ApplicationsReceived';
import { usePermissions } from '@/hooks/usePermissions';
import { paths } from '@/routes/paths';
import { PERMISSIONS } from '@/types/roles';

/** One internship's applicants, opened from View Applications on its box. */
export function CompanyInternshipApplicationsPage() {
  const { id = '' } = useParams();
  const { can } = usePermissions();
  // The route asks for reading applications; the title needs its own permission.
  const canReadInternship = can(PERMISSIONS.INTERNSHIP_READ);

  const { data: internship } = useQuery({
    queryKey: ['company-internship', id],
    queryFn: () => companyApi.getInternship(id),
    enabled: canReadInternship,
  });

  return (
    <div>
      {canReadInternship && (
        <Link
          to={paths.company.internshipDetail(id)}
          className="text-ink-muted hover:text-ink mb-3 inline-flex items-center gap-1 text-sm"
        >
          <Icon name="chevron" size={14} className="rotate-180" />
          Back to the internship
        </Link>
      )}
      <PageHeader
        title={internship?.title ?? 'Applications'}
        description="Best fit first. The match compares each applicant with this internship."
      />
      <ApplicationsReceived internshipId={id} />
    </div>
  );
}
